<template>
    <div class="info-box" :class="getCardClass" v-scroll="handleScroll">
        <div class="info-box__text">
            <slot name="icon">
                <Icon icon="Info"/>
            </slot>
            <slot name="text"></slot>
        </div>
        <span class="divider"></span>
        <div class="info-box__links">
            <slot name="links"></slot>
        </div>
    </div>
</template>

<script>
    import Icon from '@/components/Icon.vue'

    export default {

        name: 'InfoBox',

        components: {
            Icon
        },

        data: function() {

            return {

                reveal: false,
                scrolled: false,

            }

        },

        computed: {

            getCardClass: function() {

                var c = 'fx infobox';

                if ( this.$data.scrolled ) {

                    c += ' fx--on';

                }

                if ( this.flip && this.$data.reveal ) {

                    c += ' js-reveal';

                }

                return c;

            },
        },

        methods: {
            handleScroll: function(e, el) {
                var bounding = el.getBoundingClientRect();
                if ( (window.innerHeight - bounding.top) >= (window.innerHeight/3) ) {
                    this.$data.scrolled = true;
                };
            },

            handleFocus: function() {
                this.$data.scrolled = true;
            }
        }
    }
</script>

<style lang="scss">

    .info-box {
        margin: 3rem 0;

        @include mq('tab') {
            display: flex;
            margin: 5rem -1rem;
            padding: 0 1.625rem;
        }


        &.fx {
            opacity: 0;
            transform: translate3d(0, -30px, 0);
            transition: opacity 1s ease, transform 1.2s ease;
        }

        &.fx--on {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }


        &__text {


            @include mq('tab') {
                flex: 1 0 68%;
                padding: 0 3.5rem 0 1rem;
            }
        }

        .divider {
            display: none;
        }

        &__text p {
            font-size: 1.125rem;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            color: $grey-dark;
        }

        &__text a {
            color: $grey-dark;
        }

        &__text a:hover,
        &__text a:focus {
            color: $red;
        }

        &__links {

            @include mq('tab') {
                flex: 1 0 32%;
                padding: 0 1rem 0 3.5rem;
                border-left: solid 1px $blue-dark;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }

        .info-box__text svg {
            fill: $blue;
        }

        &.vertical {
            margin: 0;
            padding: 0;

            @include mq('tab') {
                display: block;
            }

            .info-box__text {
                padding: 0 0 2rem 0;
            }

            .info-box__text svg {
                fill: $blue-dark;
            }

            .info-box__text p {
                margin-bottom: 0;
                color: $blue-dark;
            }

            .info-box__links {
                padding: 2rem 0 0 0;
                border-left: 0;
            }

            .divider {
                display: block;
                width: 140px;
                border-top: solid 1px
            }
        }

        &.icon-left .info-box__text {

            @include mq('lap') {
                display: flex;
            }
        }

        &.icon-left .icon {

            @include mq('lap') {
                margin-top: 1.4rem;
                padding-right: 2rem;
            }
        }

        &.icon-black .icon svg {
            fill: $black;
        }

        &.icon-red .icon svg {
            fill: $red;
        }
    }

    .info-box__links a {
        display: block;
        width: 100%;
        font-size: 1.125rem;
        font-weight: 600;
        color: $blue-dark;
        text-decoration: none;
        margin-bottom: 1rem;
        transition: color .2s ease;

        &:hover,
        &:focus {
            color: $red;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .info-box__links .icon {
        display: inline;
        padding-left: .75rem;
        transition: all .2s ease;
        position: relative;
        left: 0;
        fill: $blue-dark;
    }

    .info-box__links a:hover .icon,
    .info-box__links a:focus .icon {
        left: 3px;
        fill: $red;
    }

    .app-links a {
        display: block;
    }

    .info-box .app-link--apple {
        max-width: 150px;
        margin-bottom: 0;
    }

    .info-box .app-link--google {
        max-width: 174px;
        margin-left: -11px;
        margin-bottom: 0;
    }

</style>